import React from 'react';

//interfaces
import { IMinimisedElement } from '../../../interfaces/IFormElement';
import { IconLibrary } from '../../../../../interfaces/icon/IconLibrary';

//components
import ElementTypeInformation from '../../elements/ElementTypeInformation';
import IconButton from '../../../../global/buttons/IconButton';



const  MinimisedElementDetails = ({elementType, labelText, isRequiredElement, onDeleteElementClick, onEditElementClick, dragRef, validationErrors}: IMinimisedElement ) => {

    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;

    return (
        <div className={`form-element-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`}>
            <div className='form-element-type-details'>
                <h3 
                    className='form-element-label-text'
                    onClick={onEditElementClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onEditElementClick(); }}
                >
                    {labelText}{isRequiredElement ? "*" : ""}
                </h3>

                <ElementTypeInformation
                    className='reversed-elements'
                    elementType={elementType}
                    withBrackets
                />
            </div>

            <div className='form-element-control-panel'>
                    <IconButton 
                        ariaLabel={'Remove Form Element'} 
                        className={'icon-button-squared control-button'} 
                        iconName={IconLibrary.BIN} 
                        onButtonClick={onDeleteElementClick}
                    />

                    <IconButton 
                        ariaLabel={'Edit Form Element'} 
                        className={'icon-button-squared control-button'} 
                        iconName={IconLibrary.PENCIL} 
                        onButtonClick={onEditElementClick}
                    />

                    <IconButton 
                        ariaLabel={'Drag to Reorder Element'} 
                        className={'icon-button-squared control-button drag'} 
                        iconName={IconLibrary.DRAG}
                        parentRef={dragRef}
                    />                    
            </div>
        </div>
    );
};

export default MinimisedElementDetails